module.exports = __webpack_public_path__ + "img/Admin_Portal_Icon.9c0cbfcd.jpg";